var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"chat-upload",attrs:{"action":"","show-file-list":false,"http-request":_vm.sendImg,"before-upload":_vm.beforeUpload}},[_c('i',{staticClass:"chat iconfont iconimage"})])
}
var staticRenderFns = []

export { render, staticRenderFns }